// extracted by mini-css-extract-plugin
export default {"imageWrapper":"SI-z","twoColumnImage":"TI-z"};